/* global Swiper:false anime:false  */

(function () {
	"use strict";

	// swiper for hero slider

	let heroSwiper = null;
	let currentBanner;

	// set boolen to perform the slide animations for one time only
	var animate_totalCloudRisk = true,
		animate_etmBanner = true,
		animate_totalappsecBanner = true,
		animate_emeaBanner = true,
		// animate_americaBanner = true,
		animate_unicornsBanner = true,
		animate_policyAuditBanner = true,
		animate_totalAiBanner = true;

		// always keep the regular slides for future use: QSC, CRS events. don't forget to uncomment the slides in the partial first
		// animate_crsBanner = true;



	function animateFirstSlide(){
		// place the animation for the first slide here, the animation will be played on swiper load event
		if(animate_unicornsBanner ){
			animate_unicornsBanner = false;
			anime({
				targets: ".js-Unicorn-slide-anim .anim",
				translateY: [100, 0],
				opacity: [0, 1],
				duration: 700,
				easing: "easeOutQuint",
				delay: anime.stagger(250)
			});

		}
	}

	const initHeroSwiper = () => {
		heroSwiper = new Swiper(".js-home-hero-slider", {
			slidesPerView: 1,
			centeredSlides: false,
			autoplay: {
				delay: 8000
			},
			autoHeight: false,
			loop: false,
			pagination: {
				el: ".js-home-hero-slider .swiper-pagination",
				clickable: true,
			},
			on: {
				// animate the first slide on load event
				init: animateFirstSlide,
				// animate other slides on slide change event
				slideChange: function () {

					var activeIndex = this.activeIndex;
					var activeSlide = this.slides[activeIndex];
					currentBanner = activeSlide.dataset.banner;

					if(currentBanner === "totalAiBanner" && animate_totalAiBanner ){
						animate_totalAiBanner = false;
						anime({
							targets: ".js-titalai-slide-anim .anim",
							translateY: [100, 0],
							opacity: [0, 1],
							duration: 700,
							easing: "easeOutQuint",
							delay: anime.stagger(250)
						});
					}
					else if(currentBanner === "policyAuditBanner" && animate_policyAuditBanner ){
						animate_policyAuditBanner = false;
						anime({
							targets: ".js-policy-audit-slide-anim .anim",
							translateY: [100, 0],
							opacity: [0, 1],
							duration: 700,
							easing: "easeOutQuint",
							delay: anime.stagger(250)
						});
					}
					else if (currentBanner === "qscEMEABanner" && animate_emeaBanner) {
						animate_emeaBanner = false;

						const deriskCycle = document.querySelectorAll(".js-derisk-cycle .anim-rotate");
						const tl = anime.timeline({
							loop: true,
							easing: "linear"
						});

						anime({
							targets: ".js-qsc-emea-slide-anim .anim",
							translateY: [100, 0],
							opacity: [0, 1],
							duration: 700,
							easing: "easeOutQuint",
							delay: anime.stagger(250),
							begin: function(){
								deriskCycle.forEach(cycle => {
									tl
									.add({
										targets: cycle,
										opacity: [0, 1],
										duration: 500
									})
									.add({
										targets: cycle,
										opacity: 1,
										duration: 1000
									})
									.add({
										targets: cycle,
										opacity: [1, 0],
										duration: 500
									});
								});
							}
						});
				}

				else if (currentBanner === "totalappsecBanner" && animate_totalappsecBanner) {
						animate_totalappsecBanner = false;
						anime({
							targets: ".q-totalappsec .anim",
							translateY: [100, 0],
							opacity: [0, 1],
							duration: 700,
							easing: "easeOutQuint",
							delay: anime.stagger(250)
						});
				}

				else if(currentBanner === "etmBanner" && animate_etmBanner){
						animate_etmBanner = false;
						anime({
							targets: ".q-etm .anim",
							translateY: [100, 0],
							opacity: [0, 1],
							duration: 700,
							easing: "easeOutQuint",
							delay: anime.stagger(250)
						});
					}

					else if (currentBanner === "totalCloudRisk" && animate_totalCloudRisk) {
						animate_totalCloudRisk = false;
						anime({
							targets: ".js-total-cloud-risk-slide-txt .stgr",
							translateY: [100, 0],
							opacity: [0, 1],
							duration: 700,
							easing: "easeOutQuint",
							delay: anime.stagger(250)
						});
					}

				}
			}
		});
	};

	const handleHeroSwiper = () => {
		if (!heroSwiper && document.querySelector(".js-home-hero-slider")) {
			initHeroSwiper();
		}
	};
	window.addEventListener("load", handleHeroSwiper);
	window.addEventListener("resize", handleHeroSwiper);

	//Swiper for Blog container

	let blogSwiper = null;
	const initBlogSwiper = () => {
		blogSwiper = new Swiper(".js-blog-container", {
			slidesPerView: 1,
			centeredSlides: false,
			freeMode: true,
			spaceBetween: 15,
			grabCursor: true,
			breakpoints: {
				640: {
					slidesPerView: 2,
					spaceBetween: 15,
				},
				960: {
					slidesPerView: 3,
					spaceBetween: 15,
				},
				1240: {
					slidesPerView: 4,
					spaceBetween: 28,
				}
			},
			pagination: {
				el: ".js-blog-container .swiper-pagination",
				clickable: true,
			}
		});
	};

	const handleBlogSwiper = () => {
		if (!blogSwiper && document.querySelector(".js-blog-container")) {
			initBlogSwiper();
		}
	};
	window.addEventListener("load", handleBlogSwiper);
	window.addEventListener("resize", handleBlogSwiper);

	//Swiper for events carousel

	let eventsCarousel = null;
	const initEventsCarousel = () => {
		eventsCarousel = new Swiper(".js-events-carousel", {
			slidesPerView: "auto",
			centeredSlides: false,
			spaceBetween: 32,
			pagination: false
		});
	};

	const handleEventsCarousel = () => {
		if (!eventsCarousel && document.querySelector(".js-events-carousel")) {
			initEventsCarousel();
		}
	};
	window.addEventListener("load", handleEventsCarousel);
	window.addEventListener("resize", handleEventsCarousel);

	// events slider

	let eventsSlider = null;
	const initEventsSlider = () => {
		eventsSlider = new Swiper(".js-events-slider", {
			slidesPerView: "auto",
			centeredSlides: false,
			spaceBetween: 32,
			pagination: {
				el: ".js-events-slider .swiper-pagination",
				clickable: true,
			}
		});
	};

	const handleEventsSlider = () => {
		if (!eventsSlider && document.querySelector(".js-events-slider")) {
			initEventsSlider();
		}
	};
	window.addEventListener("load", handleEventsSlider);
	window.addEventListener("resize", handleEventsSlider);

	// init desktop hero total cloud risk carousel
	new Swiper(".q-total-cloud-risk", {
		spaceBetween:50,
		slidesPerView: 2,
		centeredSlides: true,
		loop: true,
		direction: 'vertical',
		navigation: false,
		allowTouchMove: false, // Disable dragging
		speed: 800,
		autoplay: {
			delay: 2500
		},
		effect: 'coverflow',
		coverflowEffect: {
		  rotate: 0,
		  slideShadows: false
		},
		 breakpoints: {
			920: {
				spaceBetween: 150,
			}
		}
	});

	new Swiper(".q-total-cloud-risk-mobile", {
		spaceBetween: 10,
		slidesPerView: 1.3,
		centeredSlides: true,
		loop: true,
		allowTouchMove: false, // Disable dragging
		navigation: false,
		autoplay:true,
		breakpoints: {
			640: {
				spaceBetween:20,
			}
		}
	});

})();

/* global Swiper:false anime:false */

(function () {
	"use strict";

	// Function to cycle images in the QSC EMEA banner
	const cycleImages = () => {

		// Get all the QSC EMEA banner images
		const bannerImages = document.querySelectorAll(".q-emea-banner-slide img");

		// Image arrays for manipulation
		const switchTime = [5000, 3000, 3000];
		let index = 0;

		// Function to update both image sets
		const updateImages = () => {

			// Cycle EMEA banner images
			bannerImages.forEach((img, i) => {
				img.style.opacity = i === index ? "1" : "0";
				img.style.zIndex = i === index ? "1" : "0";
			});

			// Move to the next image in sequence
			index = (index + 1) % bannerImages.length;

			// Set the next image switch time based on current index
			setTimeout(updateImages, switchTime[index]);
		};

		// Delay start by 3s for the Cloud image to appear first
		setTimeout(() => {
			updateImages();
		}, 2500);
	};
	// Start the image cycle when the page loads
	window.addEventListener("load", cycleImages);

})();


(function() {
	"use strict";

	new Swiper('.inner-slider', {
		loop: true,
		autoplay: {
			delay: 5000,  // Inner slider autoplay delay
		},
		speed: 1500,
		effect: 'fade',  // Use fade effect for smooth transitions
		fadeEffect: {
			crossFade: true,  // Enable smooth crossfade transitions
		},
		pagination: {
			el: '.swiper-pagination',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
})();
